import { Component, HostListener, OnInit } from "@angular/core";
import {
  AlertController,
  MenuController,
  ModalController,
  Platform,
  ToastController,
} from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { Network } from "@ionic-native/network/ngx";
import { Location } from "@angular/common";
import { NavigationStart, Router } from "@angular/router";
import { domain } from "./variables/domain";
import { SideBarEventService } from "./services/event-Emitter/side-bar.service";
import { AdminService } from "./services/admin.service";
import { SharedServices } from "./services/shared.service";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { NotificationsService } from "./services/notifications.service";
import { PushNotificationService } from "./services/push-notification.service";
import { Device } from '@capacitor/device';
import { EncryptionService } from "./services/encryption.service";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { SharedService } from "./core-files/shared.service.";
import { AgentCityComponent } from "./shared-module/components/agent-city/agent-city.component";
import { MatDialog } from "@angular/material/dialog";
import { LoginService } from "./services/login.service";
// import { DeviceImeiService } from "./services/device-imei.service";


@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
  standalone: false,
})
export class AppComponent implements OnInit {
  agentCity: any = null;
  isBackButton: boolean = true;
  pageURL: any;
  agentName: string;
  agentMailId: string;
  agentMobileNumber: any;
  ProfilePic: string = "";
  ProfileURL = domain.imageURL;
  userType: any;
  isDataLoad: any;
  userToken: any
  isloggedIn: any;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private network: Network,
    public toastController: ToastController,
    public alertController: AlertController,
    private _location: Location,
    public router: Router,
    private menu: MenuController,
    private sideBarEventService: SideBarEventService,
    private adminService: AdminService,
    private sharedServices: SharedServices,
    private sharedService: SharedService,
    private notificationsService: NotificationsService,
    private pushNotificationService: PushNotificationService,
    private modalCtrl: ModalController,
    private dialog: MatDialog,
    private loginService: LoginService,
    private encryptionService: EncryptionService,
    // private deviceImeiService: DeviceImeiService

  ) {
    this.initializeApp();

    this.platform.ready().then((plat) => {
      this.statusBar.styleDefault();
        this.handleBackButton();
      if (Capacitor.isNativePlatform()) {
        // Never let a push notification failure block app startup.
        this.pushNotificationService.initPushNotifications().catch((error) => {
          console.error("Push notification initialization failed:", error);
        });
        this.registerUserDevice().catch((error) => {
          console.error("Device registration failed:", error);
        });
      } else {
        this.redirectToNativeAppIfInstalled();
      }
      // if (plat != "dom") {
      //   this.router.navigateByUrl("splash-screen");
      //   this.notificationsService.initPush() 
      // }
    }).catch(e => {
      console.error("Platform ready failed:", e);
    });
  }

  /** Web build only: try to open the installed native app (checked via its package/URL scheme); if it isn't installed, the user simply continues on the web page. */
  private redirectToNativeAppIfInstalled() {
    if (sessionStorage.getItem("nativeAppRedirectAttempted")) {
      return;
    }
    sessionStorage.setItem("nativeAppRedirectAttempted", "true");

    const userAgent = navigator.userAgent || "";
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iphone|ipad|ipod/i.test(userAgent);
    if (!isAndroid && !isIOS) {
      return; // desktop browsers: nothing to open, continue with web
    }

    const fallbackUrl = window.location.href;

    if (isAndroid) {
      const hostAndPath = fallbackUrl.replace(/^https?:\/\//, "");
      // Android resolves the package itself; if it's not installed it automatically falls back to browser_fallback_url
      const intentUrl = `intent://${hostAndPath}#Intent;scheme=${domain.AppUrlScheme};package=${domain.AppPackageId};S.browser_fallback_url=${encodeURIComponent(fallbackUrl)};end`;
      window.location.href = intentUrl;
    } else if (isIOS) {
      // iOS has no automatic fallback for custom schemes; if the app isn't installed this silently fails and the user stays on the web page
      window.location.href = `${domain.AppUrlScheme}://open`;
    }
  }
  ngOnDestroy() {
  
  }
    handleBackButton() {
    // Custom logic for back button
    // You can show a confirmation dialog
    // Or exit the app on mobile
  }
  /** Registers this device with the backend via the AddUserDevice API. */
  async registerUserDevice() {
    try {
      const deviceToken = this.pushNotificationService.getDeviceToken();
      if (!deviceToken) {
        // Token not available yet — the push registration listener in
        // PushNotificationService calls AddUserDevice once FCM/APNs returns it.
        return;
      }

      let deviceId = "";
      try {
        const idInfo = await Device.getId();
        deviceId = idInfo?.identifier || "";
      } catch (error) {
        console.error("Failed to read device id:", error);
      }

      const payload = {
        deviceType: Capacitor.getPlatform() === "android" ? "Android" : "iOS",
        deviceToken: deviceToken,
        mobileDeviceId: deviceId,
      };

      try {
        this.adminService.AddUserDevice(payload).subscribe({
          next: (res: any) => {
            // Device registered successfully.
          },
          error: (err: any) => {
            // Registration failed; it will retry on next app launch.
            console.error("AddUserDevice API call failed:", err);
          },
        });
      } catch (error) {
        console.error("Failed to issue AddUserDevice request:", error);
      }
    } catch (e) {
      // Best-effort registration — never let this crash app startup.
      console.error("Unexpected error registering user device:", e);
    }
  }
  ngOnInit() {
     this.router.events.pipe(
    filter(event => event instanceof NavigationStart && event.navigationTrigger === 'popstate')
  ).subscribe(async (event: NavigationStart) => {
    // This code will execute when the browser's back/forward button is clicked
    this.sharedService.setBrowserBackButton(true);
    const modal = await this.modalCtrl.getTop();
    if (modal) {
      this.modalCtrl.dismiss();
      this.platform.backButton.observers.pop();
    } else if (this.dialog.openDialogs.length > 0) {
      this.dialog.closeAll();
      this.platform.backButton.observers.pop();
    }
    // You can add your specific logic here, e.g., show a confirmation dialog,
    // prevent navigation, or perform data cleanup.
  });
     
    this.userToken = localStorage.getItem("a_n_d");

    if (this.userToken !== null && this.userToken !== undefined) {
      this.sharedServices.setLogedIn();
    } else {
      this.sharedServices.setLogedIn();
    }

    this.network.onConnect().subscribe(async () => {
      const toast = await this.toastController.create({
        message: "Back to Online",
        position: "top",
        duration: 3000,
        color: "success",
      });
      toast.present();
    });

    this.network.onDisconnect().subscribe(async () => {
      const toast = await this.toastController.create({
        message: "You are offline Please check Internet connection",
        position: "top",
        duration: 4000,
        color: "danger",
      });
      toast.present();
    });
  }
  async  initializeApp() {
    this.isloggedIn = this.sharedServices.getLogedIn();
    if (this.isloggedIn) {
      if(localStorage.getItem("selectedCity") !== null && localStorage.getItem("selectedCity") !== undefined){
        this.agentCity = JSON.parse(this.encryptionService.decryptUsingAES256(localStorage.getItem("selectedCity")));
      }
      this.loginService.GetAgentCity(parseInt(this.encryptionService.decryptUsingAES256(localStorage.getItem("a_n_d")))).subscribe({
        next: (res: any) => {
          if (res.CityId !=0) {
            localStorage.setItem('selectedCity', this.encryptionService.encryptUsingAES256(JSON.stringify({ id: res.CityId, name: res.City })));
          }
         },
        error: (err: any) => {
        }
      });
      if (this.agentCity === null || this.agentCity === undefined) {
        this.dialog.open(AgentCityComponent, {
          width: "min(960px, 90vw)",
          maxWidth: "500px",
          hasBackdrop: true,
          // backdropClass: "agent-city-backdrop",
        });
      }
    }
    this.router.events.subscribe({ next: (event) => {
      if (event instanceof NavigationStart) {
        this.pageURL = event.url;
        if (
          this.pageURL.includes("/agent-home/agent-tab/activites") ||
          this.pageURL == "/" ||
          this.pageURL == "/login" ||
          this.pageURL === "/agent-home/agent-tab" ||
          this.pageURL === "/agent-home" ||
          this.pageURL === "/builder-home" ||
          this.pageURL === "/builder-home/builder-tabs" ||
          this.pageURL === "/agent-home/agent-tab/all-listing"
        ) {
          this.isBackButton = false;
        } else {
          this.isBackButton = true;
        }
      }
    } });
    this.platform.ready().then((plat) => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      if (plat !== "dom") {
        App.addListener("appUrlOpen", (data) => {
          const match = data.url.match(/property-detail\/([^/?#]+)\/([^/?#]+)/);
          if (match) {
            const propertyId = match[1].replace(/-/g, '/').replace(/_/g, '+').replace(/~/g, '=');
            const type = match[2].replace(/-/g, '/').replace(/_/g, '+').replace(/~/g, '=');
            this.router.navigate(["agent-home/property-detail", propertyId, type]);
          }
        });

        App.addListener("backButton", async () => {
          // this.modalCtrl.dismiss()
          const modal = await this.modalCtrl.getTop();
          if (modal) {
            this.modalCtrl.dismiss();
            this.platform.backButton.observers.pop();
          } else if (this.dialog.openDialogs.length > 0) {
            this.dialog.closeAll();
            this.platform.backButton.observers.pop();
          } else {
            if (
              this.pageURL.includes("/agent-home/agent-tab/home") ||
              this.pageURL == "/" ||
              this.pageURL === "/agent-home/agent-tab" ||
              this.pageURL === "/agent-home"
            ) {
              navigator["app"].exitApp();
            } else {
              this._location.back();
            }
          }
        });

      }
    });
  }
  showExitConfirm() {
    this.alertController
      .create({
        header: "App termination",
        message: "Do you want to close the app?",
        backdropDismiss: false,
        buttons: [
          {
            text: "Stay",
            role: "cancel",
            handler: () => { },
          },
          {
            text: "Exit",
            handler: () => {
              navigator["app"].exitApp();
            },
          },
        ],
      })
      .then((alert) => {
        alert.present();
      });
  }
  backButtonEvent() {
    document.addEventListener("backbutton", () => {
      this.modalCtrl.dismiss();
      this.dialog.closeAll();
      if (this.pageURL == "/agent;skipLocationChange=true") {
        this.showExitConfirm();
      } else {
        this._location.back();
      }
    });
  }

 
}
